/**
 * WTQ cart drawer router
 * - App upsell / third-party cart drawer ON  → do not open theme cart-drawer (app owns UI)
 * - App OFF + theme cart type "drawer"         → theme cart-drawer.show() after ATC
 * - product-form (is="product-form") always AJAX-adds; this only controls which drawer opens
 *
 * Zipify OCU: open = .ocu-cart-drawer.ocu-visible | closed = .ocu-cart-drawer (no ocu-visible)
 */
(function () {
  'use strict';

  function hasAppCartDrawer() {
    try {
      if (window.WTQ_FORCE_THEME_CART === true) return false;
      if (window.WTQ_FORCE_APP_CART === true) return true;

      if (document.documentElement.hasAttribute('data-app-cart-drawer')) return true;
      if (document.body && document.body.getAttribute('data-app-cart-drawer') === 'true') return true;

      var selectors = [
        '.ocu-cart-drawer',
        '#single-ocu-app',
        '.single-ocu-app',
        '#slidecart-container',
        '.slidecarthq',
        '#slidecart',
        'upcart-popup',
        '#upcart-popup',
        '.upcart-mini-cart',
        '#rebuy-cart',
        '.rebuy-cart__flyout',
        '[class*="upsell-cart-drawer"]',
        '[id*="upsell-cart"]',
        '[data-cart-drawer="app"]',
        '[data-app-cart-drawer]',
        'cart-upsell-popup',
        '#cart-drawer-container:not(cart-drawer)'
      ];
      for (var i = 0; i < selectors.length; i++) {
        if (document.querySelector(selectors[i])) return true;
      }

      if (
        window.SLIDECART ||
        window.SLIDECART_SETTINGS ||
        window.upCart ||
        window.Upcart ||
        window.Rebuy ||
        window.rebuy ||
        window.ZipifyOCU ||
        window.zipify
      ) {
        return true;
      }

      var scripts = document.getElementsByTagName('script');
      for (var j = 0; j < scripts.length; j++) {
        var src = scripts[j].src || '';
        if (/slidecart|upcart|rebuy\.io|upsell.?cart|cart-drawer\.app|zipify|oneclickupsell|ocu/i.test(src)) return true;
      }

      return false;
    } catch (e) {
      return false;
    }
  }

  function hasThemeCartDrawer() {
    return !!document.querySelector('cart-drawer#CartDrawer, cart-drawer');
  }

  function findCartTrigger() {
    return (
      document.querySelector('.cart-drawer-button') ||
      document.querySelector('a[aria-controls="CartDrawer"]') ||
      document.querySelector('a[href="/cart"]') ||
      document.querySelector('a[href$="/cart"]') ||
      document.querySelector('#cart-icon-bubble') ||
      document.querySelector('.header__icon--cart')
    );
  }

  function isOcuOpen(drawer) {
    return !!(drawer && drawer.classList.contains('ocu-visible'));
  }

  /**
   * Click header cart control WITHOUT following href="/cart".
   * Bare .click() on that link was sending buyers to the cart page.
   */
  function clickCartTriggerSafely(trigger) {
    if (!trigger) return false;

    var href = trigger.getAttribute ? trigger.getAttribute('href') : null;
    var isCartLink = trigger.tagName === 'A' && href && /\/cart\/?($|\?)/.test(href);

    function blockNavigate(e) {
      e.preventDefault();
    }

    if (isCartLink) {
      trigger.addEventListener('click', blockNavigate, true);
      // Neutralize href for this synthetic open so the browser cannot navigate.
      trigger.setAttribute('href', '#');
    }

    try {
      trigger.dispatchEvent(
        new MouseEvent('click', { bubbles: true, cancelable: true, view: window })
      );
    } catch (e1) {
      try { trigger.click(); } catch (e2) {}
    }

    if (isCartLink) {
      setTimeout(function () {
        trigger.removeEventListener('click', blockNavigate, true);
        trigger.setAttribute('href', href);
      }, 0);
    }

    return true;
  }

  /**
   * Open Zipify OCU without leaving the page.
   * Prefer native cart-icon click (with /cart navigation blocked) so close works;
   * fall back to .ocu-visible + wired close.
   */
  function openOcuCartDrawer() {
    var drawer = document.querySelector('.ocu-cart-drawer');
    if (!drawer) return false;
    if (isOcuOpen(drawer)) return true;

    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('wtq:cart:added-app', { bubbles: true }));
    } catch (e) {}

    clickCartTriggerSafely(findCartTrigger());

    // If OCU did not open via its own handler, force visible AND wire close so X works.
    setTimeout(function () {
      if (isOcuOpen(drawer)) return;
      drawer.classList.add('ocu-visible');
      drawer.setAttribute('aria-hidden', 'false');
      wireForcedOcuClose(drawer);
    }, 120);

    return true;
  }

  function wireForcedOcuClose(drawer) {
    if (!drawer || drawer.__wtqOcuCloseWired) return;
    drawer.__wtqOcuCloseWired = true;

    function closeForced() {
      drawer.classList.remove('ocu-visible');
      drawer.setAttribute('aria-hidden', 'true');
    }

    drawer.addEventListener('click', function (e) {
      var btn = e.target.closest(
        'button, [role="button"], a, .ocu-cart-close, [class*="close"], [aria-label*="close" i], [aria-label*="Close"]'
      );
      if (!btn || !drawer.contains(btn)) return;
      // Header close / X — not qty +/- or checkout
      var label = ((btn.getAttribute('aria-label') || '') + ' ' + (btn.className || '') + ' ' + (btn.textContent || '')).toLowerCase();
      var isClose =
        label.indexOf('close') !== -1 ||
        (btn.className && String(btn.className).toLowerCase().indexOf('close') !== -1) ||
        (btn.closest('.ocu-cart-header') && btn.tagName === 'BUTTON');
      if (!isClose) return;
      // Let OCU run first; if still open, force-close our class.
      setTimeout(function () {
        if (isOcuOpen(drawer)) closeForced();
      }, 0);
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOcuOpen(drawer) && drawer.__wtqOcuCloseWired) {
        closeForced();
      }
    });
  }

  function openAppCartDrawer(focusEl) {
    if (openOcuCartDrawer()) return 'ocu';

    document.dispatchEvent(new CustomEvent('wtq:cart:added-app', { bubbles: true, detail: { focus: focusEl || null } }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));

    // Generic: if another app drawer exists but we can't open it, still report app.
    return 'app';
  }

  window.WTQCart = {
    hasAppCartDrawer: hasAppCartDrawer,
    hasThemeCartDrawer: hasThemeCartDrawer,
    openOcuCartDrawer: openOcuCartDrawer,
    /**
     * After a successful add-to-cart.
     * Theme product-form already calls cart-drawer.show(); this is for other buttons.
     * Only opens an app drawer when that app is present; otherwise theme drawer.
     */
    openAfterAdd: function (focusEl) {
      if (window.__WTQ_REDIRECTING_TO_CHECKOUT || document.documentElement.classList.contains('wtq-redirecting')) {
        return 'none';
      }
      if (hasAppCartDrawer()) {
        return openAppCartDrawer(focusEl);
      }
      if (hasThemeCartDrawer()) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') {
          drawer.show(focusEl || null);
          return 'theme';
        }
      }
      return 'none';
    }
  };

  function patchThemeCartDrawerShow() {
    var Ctor = customElements.get('cart-drawer');
    if (!Ctor || !Ctor.prototype || Ctor.prototype.__wtqCartPatched) return;

    var originalShow = Ctor.prototype.show;
    Ctor.prototype.show = function (focusElement, animate) {
      if (window.__WTQ_REDIRECTING_TO_CHECKOUT) {
        return;
      }
      // App cart drawer enabled → leave UI to the app (theme drawer stays closed)
      if (hasAppCartDrawer()) {
        document.dispatchEvent(
          new CustomEvent('wtq:theme-cart-drawer:suppressed', {
            bubbles: true,
            detail: { reason: 'app-cart-drawer' }
          })
        );
        return;
      }
      return originalShow.call(this, focusElement, animate);
    };
    Ctor.prototype.__wtqCartPatched = true;
  }

  if (customElements.get('cart-drawer')) {
    patchThemeCartDrawerShow();
  } else if (customElements.whenDefined) {
    customElements.whenDefined('cart-drawer').then(patchThemeCartDrawerShow);
  }

  // Re-check when late app widgets inject into DOM
  if (typeof MutationObserver !== 'undefined') {
    var obs = new MutationObserver(function () {
      // no-op: hasAppCartDrawer() is read live on each show()
    });
    document.addEventListener('DOMContentLoaded', function () {
      obs.observe(document.documentElement, { childList: true, subtree: true });
    });
  }
})();

// One tap = one product in checkout (CRO Checkout Fix).
// Product-page forms, membership cards, pricing cards, and buy forms with return_to=/checkout:
// 1. Force quantity to 1 for all checkout buy flows.
// 2. Disable Buy button immediately on first tap to prevent rapid repeated taps and duplicates.
// 3. Clear cart first so previous items are never carried into checkout.
// 4. Preserve Qi Mat & physical products exception (routes to cart drawer, never clears or forces checkout).
// 5. Replace 400ms delay with immediate redirect & Shopify Customer Events analytics publish.
(function () {
  if (window.__WTQ_CLEAR_BEFORE_CHECKOUT__) return;
  window.__WTQ_CLEAR_BEFORE_CHECKOUT__ = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  var CLEAR_URL = root + 'cart/clear.js';
  var ADD_URL = root + 'cart/add.js';
  var CART_URL = root + 'cart.js';
  var CHANGE_URL = root + 'cart/change.js';
  // One membership per checkout (Oct 2026): before checkout, keep only the line just added, at quantity 1.
  function wtqNormalizeCart(added) {
    var keepKey = added && (added.key || (added.items && added.items[0] && added.items[0].key));
    return fetch(CART_URL, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        if (!keepKey && items.length) keepKey = items[0].key;
        var chain = Promise.resolve();
        items.forEach(function (it) {
          var want = it.key === keepKey ? 1 : 0;
          if (it.quantity !== want) {
            chain = chain.then(function () {
              return fetch(CHANGE_URL, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ id: it.key, quantity: want }) });
            });
          }
        });
        return chain;
      })
      .catch(function () {});
  }
  function wtqIsPlanForm(f) { return !!(f && isCheckoutAddForm(f) && (f.querySelector('input[name="selling_plan"]') || f.querySelector('[data-appstle-product-id], .appstle_stand_alone_selector'))); }
  // Membership and payment-plan forms: no quantity picker, quantity always 1.
  function wtqLockQty() {
    if (!document.getElementById('wtq-plan-qty-css')) { var st = document.createElement('style'); st.id = 'wtq-plan-qty-css'; st.textContent = 'form:has(input[name="selling_plan"]) quantity-input{display:none!important}'; (document.head || document.documentElement).appendChild(st); }
    document.querySelectorAll('form').forEach(function (f) {
      if (!wtqIsPlanForm(f)) return;
      var ins = Array.prototype.slice.call(f.querySelectorAll('input[name="quantity"]'));
      if (f.id) ins = ins.concat(Array.prototype.slice.call(document.querySelectorAll('input[name="quantity"][form="' + f.id + '"]')));
      ins.forEach(function (q) { q.value = '1'; var w = q.closest('quantity-input'); if (w) w.style.display = 'none'; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wtqLockQty); else setTimeout(wtqLockQty, 0);
  // Express wallet buttons (Apple Pay, Shop Pay, Buy it now) on membership forms go through the same one-item path.
  document.addEventListener('click', function (e) {
    var host = e.target && e.target.closest ? e.target.closest('shopify-accelerated-checkout, .shopify-payment-button') : null;
    if (!host) return;
    var form = host.closest('form');
    if (!wtqIsPlanForm(form)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (form.__wtqBusy || form.__wtqRedirecting) return;
    disableBuyButtons(form, null);
    goCheckoutWithSingleItem(form, null);
  }, true);
  // Back button from checkout (Safari page cache): unlock the buy buttons.
  window.addEventListener('pageshow', function (ev) {
    if (!ev.persisted) return;
    window.__WTQ_REDIRECTING_TO_CHECKOUT = false;
    document.documentElement.classList.remove('wtq-redirecting');
    if (document.body) document.body.classList.remove('wtq-redirecting');
    document.querySelectorAll('form').forEach(function (f) { if (f.__wtqBusy || f.__wtqRedirecting) { f.__wtqRedirecting = false; enableBuyButtons(f, null); } });
  });

  // Physical merchandise & Qi Mat handles that must ALWAYS use normal cart drawer
  var PHYSICAL_HANDLES = ['qi-mat', 'merchandise', 'clothing', 'shirt', 'flare-pants', 'tote'];

  function isPhysicalProduct(form) {
    if (!form) return false;
    var handle = (form.getAttribute('data-product-handle') || '').toLowerCase();
    for (var i = 0; i < PHYSICAL_HANDLES.length; i++) {
      if (handle === PHYSICAL_HANDLES[i] || handle.indexOf(PHYSICAL_HANDLES[i]) !== -1) {
        return true;
      }
    }
    if (form.getAttribute('data-requires-shipping') === 'true') return true;
    if (form.querySelector('[data-requires-shipping="true"]')) return true;
    return false;
  }

  function isCheckoutAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    if (isPhysicalProduct(form)) return false;

    var action = form.getAttribute('action') || form.action || '';
    var hasAddAction = String(action).indexOf('/cart/add') !== -1;
    var isOmForm = form.classList.contains('wtq-om-form') || form.hasAttribute('data-om-subscription');
    var isFeForm = form.classList.contains('fe-price-form') || form.hasAttribute('data-fe-add-to-cart');
    var isProductForm = (typeof form.matches === 'function')
      ? form.matches('form[is="product-form"], form.product-form, form[data-type="add-to-cart-form"]')
      : (form.classList.contains('product-form') || form.getAttribute('data-type') === 'add-to-cart-form');

    if (!hasAddAction && !isOmForm && !isFeForm && !isProductForm) return false;

    // Check explicit cart drawer intent
    if (form.getAttribute('data-wtq-redirect') === 'cart') return false;

    // 1. Digital product-page forms with quantity/variant picker (CRO Requirement: extend cart-clear)
    if (isProductForm) return true;

    // 2. Pricing cards & order menu forms
    if (isFeForm || form.hasAttribute('data-fe-add-to-cart')) return true;

    // 3. Return_to checkout markers
    var rt = form.querySelector('input[name="return_to"]');
    if (rt) {
      var v = String(rt.value || '').trim();
      if (v === '/checkout' || v === '/checkout/') return true;
    }
    if (String(action).indexOf('return_to=/checkout') !== -1) return true;
    if (form.getAttribute('data-wtq-checkout') === 'true') return true;

    // Product-page forms (e.g. form[is="product-form"]) with checkout redirect marker
    if (form.querySelector('[data-wtq-redirect="checkout"]')) return true;

    return false;
  }

  function getSelectedVariantId(form) {
    // 1. Radio button checked
    var radio = form.querySelector('input[name="id"][type="radio"]:checked');
    if (radio && radio.value) return String(radio.value).trim();

    // 2. Select dropdown
    var select = form.querySelector('select[name="id"]');
    if (select && select.value) return String(select.value).trim();

    // 3. FormData inspection
    try {
      var fd = new FormData(form);
      var id = fd.get('id');
      if (id && String(id).trim()) return String(id).trim();
    } catch (e) {}

    // 4. Any enabled input[name="id"]
    var idInput = form.querySelector('input[name="id"]:not([disabled])');
    if (idInput && idInput.value) return String(idInput.value).trim();

    // 5. Data attribute fallback
    var dataVid = form.querySelector('[data-om-variant-id], [data-variant-id-input]');
    if (dataVid && dataVid.value) return String(dataVid.value).trim();

    return null;
  }

  function normalizePlanId(val) {
    if (val == null) return '';
    var str = String(val).trim();
    if (!str || str === 'null' || str === 'undefined' || str === '0') return '';
    var lower = str.toLowerCase();
    if (lower === 'one-time' || lower === 'onetime' || lower === 'one_time' || lower === 'false') return '';
    var gidMatch = str.match(/SellingPlan\/(\d+)/i);
    if (gidMatch) return gidMatch[1];
    var numMatch = str.match(/(\d{4,})/);
    return numMatch ? numMatch[1] : '';
  }

  function getSelectedSellingPlan(form) {
    if (!form) return null;

    // 1. Check Appstle standalone widget state inside or near form
    var appstleBox = form.querySelector('.appstle_stand_alone_selector, .appstle_subscription_wrapper, [data-appstle-product-id]') ||
                     (form.parentElement ? form.parentElement.querySelector('.appstle_stand_alone_selector') : null);

    if (appstleBox) {
      var checkedRadio = appstleBox.querySelector('input[type="radio"]:checked') ||
                         form.querySelector('.appstle_subscription_radio_wrapper input[type="radio"]:checked, .appstle_stand_alone_selector input[type="radio"]:checked, input.appstle_subscription_radio:checked');

      if (checkedRadio) {
        var radioVal = String(checkedRadio.value || '').trim().toLowerCase();
        var wrapper = checkedRadio.closest('.appstle_subscription_radio_wrapper, .appstle_one_time_radio_wrapper, div') || checkedRadio.parentElement;
        var wrapperText = wrapper ? (wrapper.textContent || '').toLowerCase() : '';

        // Explicit One-Time option chosen -> strictly return null (do NOT attach a selling plan!)
        var isOneTime = radioVal === 'one-time' || radioVal === 'onetime' || radioVal === 'one_time' || radioVal === '0' ||
                        checkedRadio.classList.contains('appstle_one_time_radio') ||
                        (wrapper && wrapper.classList.contains('appstle_one_time_radio_wrapper')) ||
                        (wrapperText.indexOf('one time') !== -1 && wrapperText.indexOf('payment plan') === -1 && wrapperText.indexOf('subscri') === -1);

        if (isOneTime) {
          return null;
        }

        // Payment Plan / Subscription chosen: try attributes & values
        var planFromRadio = checkedRadio.getAttribute('data-selling-plan-id') ||
                            checkedRadio.getAttribute('data-selling-plan') ||
                            checkedRadio.getAttribute('data-plan-id') ||
                            checkedRadio.getAttribute('data-appstle-selling-plan-id') ||
                            checkedRadio.getAttribute('data-appstle-selling-plan');
        var norm = normalizePlanId(planFromRadio);
        if (norm) return norm;

        // If radio value itself is numeric
        norm = normalizePlanId(checkedRadio.value);
        if (norm) return norm;

        // Check select inside Appstle container or wrapper
        var appstleSelect = appstleBox.querySelector('select.appstle_selling_plan_select, select[name*="selling_plan"], select');
        if (appstleSelect && appstleSelect.value) {
          norm = normalizePlanId(appstleSelect.value);
          if (norm) return norm;
        }

        // Check any hidden input in Appstle container
        var hiddenPlan = appstleBox.querySelector('input[name="selling_plan"], input[name*="selling_plan"], [data-selling-plan-id]');
        if (hiddenPlan) {
          norm = normalizePlanId(hiddenPlan.value || hiddenPlan.getAttribute('data-selling-plan-id'));
          if (norm) return norm;
        }

        // Fallback from form metadata when Payment Plan is active in Appstle
        var defaultPlan = form.getAttribute('data-default-plan-id') || form.getAttribute('data-om-plan-id');
        norm = normalizePlanId(defaultPlan);
        if (norm) return norm;

        var plansScript = form.querySelector('[data-fe-selling-plans]');
        if (plansScript) {
          try {
            var plans = JSON.parse(plansScript.textContent.trim());
            if (plans && plans.length > 0 && plans[0].id) {
              norm = normalizePlanId(plans[0].id);
              if (norm) return norm;
            }
          } catch (e) {}
        }
      }
    }

    // 2. Standard checked radio with name="selling_plan" or name containing "selling_plan"
    var spRadio = form.querySelector('input[name="selling_plan"][type="radio"]:checked, input[name*="selling_plan"][type="radio"]:checked');
    if (spRadio && spRadio.value) {
      var norm = normalizePlanId(spRadio.value);
      if (norm) return norm;
    }

    // 3. Dropdown select[name="selling_plan"]
    var spSelect = form.querySelector('select[name="selling_plan"], select[name*="selling_plan"]');
    if (spSelect && spSelect.value) {
      var norm = normalizePlanId(spSelect.value);
      if (norm) return norm;
    }

    // 4. Form inputs (hidden or text) with name="selling_plan"
    var planInput = form.querySelector('input[name="selling_plan"]:not([type="radio"]):not([disabled]), [data-om-plan-id]');
    if (planInput && planInput.value) {
      var norm = normalizePlanId(planInput.value);
      if (norm) return norm;
    }

    // 5. FormData inspection
    try {
      var fd = new FormData(form);
      var sp = fd.get('selling_plan');
      var norm = normalizePlanId(sp);
      if (norm) return norm;
    } catch (e) {}

    return null;
  }

  function buildAddBody(form) {
    var variantId = getSelectedVariantId(form);
    if (!variantId) return null;

    var fd = new FormData();
    fd.append('id', variantId);
    // Requirement B: Strictly force quantity to 1 for all buy-button checkout flows
    fd.append('quantity', '1');

    // Also force form input quantity in DOM to 1 for visual & state consistency
    var qtyInput = form.querySelector('input[name="quantity"]');
    if (qtyInput) {
      qtyInput.value = '1';
    }

    var planId = getSelectedSellingPlan(form);
    if (planId) {
      fd.append('selling_plan', planId);
    }
    return fd;
  }

  function disableBuyButtons(form, clickedBtn) {
    if (clickedBtn) {
      clickedBtn.disabled = true;
      clickedBtn.setAttribute('aria-disabled', 'true');
      clickedBtn.setAttribute('aria-busy', 'true');
      clickedBtn.style.pointerEvents = 'none';
      clickedBtn.classList.add('is-loading');
    }
    if (form) {
      form.__wtqBusy = true;
      var allBtns = form.querySelectorAll('button[type="submit"], input[type="submit"], button.om-cta, .fe-atc-btn, [data-wtq-buy-btn], [data-om-add]');
      allBtns.forEach(function (b) {
        b.disabled = true;
        b.setAttribute('aria-disabled', 'true');
        b.setAttribute('aria-busy', 'true');
        b.style.pointerEvents = 'none';
        b.classList.add('is-loading');
      });
    }
  }

  function enableBuyButtons(form, clickedBtn) {
    if (clickedBtn) {
      clickedBtn.disabled = false;
      clickedBtn.removeAttribute('aria-disabled');
      clickedBtn.removeAttribute('aria-busy');
      clickedBtn.style.pointerEvents = '';
      clickedBtn.classList.remove('is-loading');
    }
    if (form) {
      form.__wtqBusy = false;
      var allBtns = form.querySelectorAll('button[type="submit"], input[type="submit"], button.om-cta, .fe-atc-btn, [data-wtq-buy-btn], [data-om-add]');
      allBtns.forEach(function (b) {
        b.disabled = false;
        b.removeAttribute('aria-disabled');
        b.removeAttribute('aria-busy');
        b.style.pointerEvents = '';
        b.classList.remove('is-loading');
      });
    }
  }

  function goCheckoutWithSingleItem(form, clickedBtn) {
    if (!form || form.__wtqRedirecting) return;
    var body = buildAddBody(form);
    if (!body) {
      enableBuyButtons(form, clickedBtn);
      return;
    }

    form.__wtqBusy = true;
    form.__wtqRedirecting = true;
    window.__WTQ_REDIRECTING_TO_CHECKOUT = true;
    document.documentElement.classList.add('wtq-redirecting');
    if (document.body) document.body.classList.add('wtq-redirecting');

    // 1. Clear cart first to prevent existing items from carrying into checkout
    fetch(CLEAR_URL, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .catch(function () { /* still attempt add */ })
      .then(function () {
        // 2. Add only the intended single item with quantity 1
        return fetch(ADD_URL, {
          method: 'POST',
          body: body,
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        });
      })
      .then(function (r) {
        if (!r || !r.ok) throw new Error('add failed');
        return r.json().catch(function () { return {}; });
      })
      .then(function (addedItem) {
        // 3. Publish Add-to-Cart event to Shopify Customer Events & custom events
        try {
          if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
            window.Shopify.analytics.publish('product_added_to_cart', {
              cartLine: {
                cost: {
                  totalAmount: {
                    amount: addedItem.final_price ? addedItem.final_price / 100 : (addedItem.price ? addedItem.price / 100 : 0),
                    currencyCode: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
                  }
                },
                merchandise: {
                  id: addedItem.id || addedItem.variant_id,
                  product: {
                    id: addedItem.product_id,
                    title: addedItem.product_title || addedItem.title || ''
                  },
                  price: {
                    amount: addedItem.final_price ? addedItem.final_price / 100 : (addedItem.price ? addedItem.price / 100 : 0),
                    currencyCode: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
                  }
                },
                quantity: 1
              }
            });
          }
          document.dispatchEvent(new CustomEvent('cart:added', { bubbles: true, detail: { product: addedItem } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } catch (e) {}

        // 4. Redirect immediately to checkout (eliminating arbitrary 400ms delay)
        wtqNormalizeCart(addedItem).then(function () { window.location.assign('/checkout'); });
      })
      .catch(function (err) {
        console.error('WTQ checkout redirect failed:', err);
        // Fallback: clear and allow native submit with quantity 1
        fetch(CLEAR_URL, { method: 'POST', credentials: 'same-origin' })
          .catch(function () {})
          .then(function () {
            form.__wtqBusy = false;
            form.__wtqRedirecting = false;
            HTMLFormElement.prototype.submit.call(form);
          });
      });
  }

  // Intercept form submission
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isCheckoutAddForm(form)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var btn = e.submitter || form.querySelector('button[type="submit"], input[type="submit"], button.om-cta, .fe-atc-btn');
    disableBuyButtons(form, btn);
    goCheckoutWithSingleItem(form, btn);
  }, true);

  // Catch button clicks immediately (capture phase) to prevent double-taps
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest
      ? e.target.closest('button[type="submit"], input[type="submit"], button.om-cta, [data-om-add], .fe-atc-btn, [data-wtq-buy-btn]')
      : null;
    if (!btn) return;

    var form = btn.form || btn.closest('form');
    if (!form || !isCheckoutAddForm(form)) return;

    // Prevent repeated taps
    if (form.__wtqBusy || form.__wtqRedirecting) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    // Immediately disable button upon first tap
    disableBuyButtons(form, btn);
    e.preventDefault();
    e.stopImmediatePropagation();
    goCheckoutWithSingleItem(form, btn);
  }, true);

  // Catch direct /cart/{variant}:{qty} links (e.g. 5 Element pricing / close tiers)
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest ? e.target.closest('a[href*="/cart/"]') : null;
    if (!link) return;

    var href = link.getAttribute('href') || '';
    var match = href.match(/\/cart\/(\d+)(?::(\d+))?/);
    if (!match) return;

    // Ensure not a physical merchandise item like Qi Mat
    var lowerHref = href.toLowerCase();
    for (var i = 0; i < PHYSICAL_HANDLES.length; i++) {
      if (lowerHref.indexOf(PHYSICAL_HANDLES[i]) !== -1) return;
    }

    var variantId = match[1];
    if (!variantId) return;

    if (link.__wtqBusy) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    link.__wtqBusy = true;
    link.style.pointerEvents = 'none';
    link.setAttribute('aria-disabled', 'true');
    window.__WTQ_REDIRECTING_TO_CHECKOUT = true;
    document.documentElement.classList.add('wtq-redirecting');
    if (document.body) document.body.classList.add('wtq-redirecting');

    e.preventDefault();
    e.stopImmediatePropagation();

    fetch(CLEAR_URL, { method: 'POST', headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .catch(function () {})
      .then(function () {
        return fetch(ADD_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        });
      })
      .then(function (r) {
        if (!r || !r.ok) throw new Error('add failed');
        return r.json().catch(function () { return {}; });
      })
      .then(function (addedData) {
        try {
          var item = (addedData.items && addedData.items[0]) || addedData;
          if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
            window.Shopify.analytics.publish('product_added_to_cart', {
              cartLine: {
                cost: { totalAmount: { amount: item.final_price ? item.final_price / 100 : 0, currencyCode: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD' } },
                merchandise: { id: item.id || variantId, product: { id: item.product_id, title: item.title || '' }, price: { amount: item.final_price ? item.final_price / 100 : 0, currencyCode: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD' } },
                quantity: 1
              }
            });
          }
        } catch (e) {}
        wtqNormalizeCart(addedData).then(function () { window.location.assign('/checkout'); });
      })
      .catch(function () {
        window.location.assign(href);
      });
  }, true);
})();
